// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__qx5FR","boxTitle":"Qualiphy_boxTitle__YigV_","box":"Qualiphy_box__1541l","toggleWrap":"Qualiphy_toggleWrap__3Uf2M"};